'use client'

import React from 'react'
import { cn } from '@/utilities/ui'

export const Container: React.FC<{
  children: React.ReactNode
  className?: string
  tag?: 'section' | 'div'
  bgClassName?: string
  px?: boolean
  mx?: boolean
}> = ({ children, className, tag = 'div', bgClassName, px = true, mx = true }) => {
  const Tag = tag
  return (
    <div className={bgClassName}>
      <Tag className={cn('relative mx-auto', px ? 'px-4' : '', mx ? 'container' : '', className)}>
        {children}
      </Tag>
    </div>
  )
}
